module.exports = __webpack_public_path__ + "static/media/unfold.5fe74a0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/unfold.svg
// module id = 711
// module chunks = 0